<template>
<div class="bg-white px-8 py-4 ">
    <lCrumbs :breadcrumb="breadcrumbItems" />
    <lcontainer class="mb-4">
        <div class="heading flex flex-row items-center justify-between py-2 px-8">
            <div>
                <div class="page text-white">Update Quiz</div>
            </div>
            <div>
                <img class="h-20" :src="require('../../../assets/quiz_image.png')" alt="" />
            </div>
        </div>
    </lcontainer>
    <div class="flex flex-wrap my-8">
        <div class="w-full md:w-1/2">
            <div class="flex flex-row flex-wrap items-center form-row mb-8 px-2">
                <div class="modal-field font-semibold">Quiz Name:</div>
                <div class="w-full sm:w-2/3 ml-auto">
                    <linput type="text" name="fname" v-model="form.title" :errorMessage="errors.title" :error="errors.title" placeholder="Title of Quiz" />
                </div>
            </div>
        </div>

        <div class="w-full md:w-1/2">
            <div class="flex flex-row flex-wrap items-center form-row mb-8 px-2">
                <div class="modal-field font-semibold">Quiz Timer:</div>
                <div class="w-full sm:w-2/3 ml-auto">
                    <linput type="text" name="fname" v-model="form.quiz_timer" :errorMessage="errors.quiz_timer" :error="errors.quiz_timer" placeholder="Timer of Quiz" />
                </div>
            </div>
        </div>

        <div class="w-full md:w-1/2">
            <div class="flex flex-row flex-wrap items-center form-row mb-8 px-2">
                <div class="modal-field font-semibold">Reward Points:</div>
                <div class="w-full sm:w-2/3 ml-auto">
                    <linput type="text" name="fname" v-model="form.reward" :errorMessage="errors.reward" :error="errors.reward" placeholder="Reward Points" />
                </div>
            </div>
        </div>

        <div class="w-full md:w-1/2">
            <div class="flex flex-row flex-wrap items-center form-row mb-8 px-2">
                <div class="modal-field font-semibold">Total Quiz Marks:</div>
                <div class="w-full sm:w-2/3 ml-auto">
                    <linput type="text" name="fname" v-model="form.total_quiz_mark" :errorMessage="errors.total_quiz_mark" :error="errors.total_quiz_mark" placeholder="Total quiz marks" />
                </div>
            </div>
        </div>

        <div class="w-full md:w-1/2">
            <div class="flex flex-row flex-wrap items-center form-row mb-8 px-2">
                <div class="modal-field font-semibold">Disable Quiz on Submit:</div>
                <div class="">
                    <input class="mx-2" type="radio" id="disable_on_submit_true" value="true" v-model="form.disable_on_submit" />
                    <label for="disable_on_submit_true">True</label>
                </div>
                <div class="">
                    <input class="mx-2" type="radio" id="disable_on_submit_false" value="false" v-model="form.disable_on_submit" />
                    <label for="disable_on_submit_false">False</label>
                </div>
            </div>
        </div>

        <div class="w-full md:w-1/2">
            <div class="flex flex-row flex-wrap items-center form-row mb-8 px-2">
                <div class="modal-field font-semibold">Retake Quiz on Request:</div>
                <div class="">
                    <input class="mx-2" type="radio" id="retake_on_request_true" value="true" v-model="form.retake_on_request" />
                    <label for="retake_on_request_true">True</label>
                </div>
                <div class="">
                    <input class="mx-2" type="radio" id="retake_on_request_false" value="false" v-model="form.retake_on_request" />
                    <label for="retake_on_request_false">False</label>
                </div>
            </div>
        </div>
    </div>
    <div v-for="(question, index) in form.questions" :key="index">
        <div class="flex flex-wrap justify-between">
            <page-header class="py-2 uppercase main-tenant-color ">Question {{ index + 1 }}</page-header>
            <linput type="text" name="fname" v-model="form.questions[index].score" placeholder="Score" />
        </div>
        <div class="my-4">

            <vue-editor :id="`editor${index}`" useCustomImageHandler v-model="form.questions[index].question_text"> </vue-editor>

            <!--<ltextarea
          v-model="form.questions[index].question_text"
          placeholder="Enter Question"
        />-->
        </div>
        <div class="modal-field font-semibold">Options:</div>
        <div class="flex flex-wrap">
            <div v-for="(option, i) in question.options" :key="i" class="w-full md:w-1/2">
                <div class="flex flex-row flex-wrap items-center form-row mb-2 px-2">
                    <input class="mx-2" type="radio" id="two" :value="i" v-model="form.questions[index].answer" />

                    <div class=" flex-grow ml-auto">
                        <linput type="text" name="fname" v-model="form.questions[index].options[i]" placeholder="Enter Option" />
                    </div>
                    <p v-if="i > 1" @click="deleteOption(index, i)" class="mx-2 cursor-pointer text-red-500">
                        Delete Option
                    </p>
                </div>
            </div>
        </div>
        <div class="flex flex-wrap justify-between">
            <p @click="addOption(index)" class="mx-2 cursor-pointer text-green-500">
                Add Option
            </p>
            <p v-if="index > 0" @click="deleteQuestion(index)" class="mx-2 cursor-pointer text-red-500">
                Remove Question
            </p>
        </div>
    </div>
    <div class="flex flex-col justify-center items-center">
        <div class="mb-2">
            <lms-button @click="addQuestion">Add Question</lms-button>
        </div>
    </div>

    <div class="flex flex-col mt-8 justify-center items-center">
        <div class="mb-2">
            <lms-button @click="handleFormSubmit">Update Quiz</lms-button>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations
} from "vuex";
import FormActions from "@/mixins/FormActions";
import {
    VueEditor
} from "vue2-editor";

export default {
    mixins: [FormActions],
    data() {
        return {
            id: "",
            errors: [],
            form: {
                questions: [{
                    question_text: "",
                    options: [null, null],
                    score: null,
                    answer: "",
                }, ],
            },
            breadcrumbItems: [{
                    disabled: true,
                    to: "/tenant/resources",
                    text: "All Resources",
                },
                {
                    disabled: true,
                    to: "#",
                    text: "Edit Quiz",
                },
            ],
        };
    },
    computed: {
        ...mapGetters(["getTenantPrograms"]),
        getPrograms() {
            let programs = this.getTenantPrograms;
            let sortedPrograms = [];
            for (let i = 0; i < programs.length; i++) {
                let temp = {
                    text: programs[i].title,
                    value: programs[i].id,
                };
                sortedPrograms = sortedPrograms.concat(temp);
            }
            return sortedPrograms;
        },
    },
    components: {
        linput: () => import("@/components/general/input"),
        ltextarea: () => import("@/components/general/textarea"),
        LmsButton: () => import("@/components/general/button"),
        lselect: () => import("@/components/forms/select"),
        PageHeader: () => import("@/components/general/pageheader"),
        lcontainer: () => import("@/components/general/container"),
        lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
        VueEditor
    },
    methods: {
        addQuestion() {
            let question = {
                question_text: "",
                options: ["", ""],
                score: 0,
                answer: 0,
            };
            this.form.questions.push(question);
        },
        deleteQuestion(index) {
            this.form.questions.splice(index, 1);
        },
        addOption(index) {
            this.form.questions[index].options.push("");
        },
        deleteOption(index, i) {
            this.form.questions[index].options.splice(i, 1);
        },
        async uploader(file) {
            let imageUrl = await this.uploadFile(file);
            this.form.course_image = imageUrl;
        },
        ...mapMutations(["updateLoader"]),
        ...mapActions([
            "tenantCreateQuiz",
            "tenantFetchSingleQuiz",
            "tenantUpdateQuiz",
        ]),
        async handleFormSubmit() {
            this.errors = [];
            this.updateLoader(true);
            let res = await this.tenantUpdateQuiz(this.form);
            this.updateLoader(false);
            if (res == true || res.status == 200 || res.status == 201) {
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Quiz Updated successfully",
                });
                this.form = {};
                this.$router.push({
                    name: "tenant-resources"
                });
            } else {
                this.errors = res.data.errors[0].source;
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.errors ?
                        res.data.errors[0].title :
                        "An error occured",
                });
            }
        },
    },
    async mounted() {
        this.updateLoader(true);
        let res = await this.tenantFetchSingleQuiz({
            id: this.$route.params.id,
        });
        this.form = res.data.data.quiz;
        this.form.questions.forEach((item) => {
            if (item.options) {
                item.options = JSON.parse(item.options);
            }
        });
        this.form.id = this.$route.params.id;
        this.updateLoader(false);
    },
};
</script>

<style lang="scss" scoped>
.form-row {
    width: 100%;
}

.modal {
    z-index: 10;

    .overlay {
        background: #b1b3b9;
        opacity: 0.89;
        z-index: 0;
    }

    .modal-content {
        width: 100%;
        width: 1001px !important;

        .modal-title {
            font-size: 24px;
            color: color(lms-tenant);
        }

        .modal-field {
            color: color(lms-tenant);
            max-width: calc(135px + 16px);
            width: 100%;
        }

        .close {
            background-color: #c2454b;
            height: 30px;
            width: 30px;
            border-radius: 50%;
            font-size: 12px;
            top: -17px;
            z-index: 2;
            right: -16px;
        }

        z-index: 1;
    }
}
</style>
